







































































import { cloneDeep, isEmpty, camelCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { Getaway } from '../logic/types'
import GetawayRequiredFieldsView
  from './GetawayRequiredFieldsView.vue'

@Component({
  components: {
    GetawayRequiredFieldsView,
  },
  methods: {
    cloneDeep,
    isEmpty,
    camelCase,
  },
})
export default class GetawayList extends Vue {
  @Prop() readonly getaways!: Array<Getaway>

  @Prop({ type: Boolean, default: false }) multiplePayment!: boolean

  @Prop({ type: Function }) calcTotalFn!: (price: string, currencySymbol?: string, basePrice?: string) => number

  @Watch('getawayData', { deep: true })
  onSelectedGetaway(value: { getaway: Getaway | null, requiredFields: any }): void {
    this.$emit('select', this.isFormInvalid ? null : value)
  }

  @Watch('getaways')
  resetSelectedGetaway(): void {
    this.selectedGetaway = this.getaways[0]
  }

  getawayData: { getaway: Getaway | null, requiredFields: any } = {
    getaway: null,
    requiredFields: null,
  }

  get selectedGetaway(): Getaway | null {
    return this.getawayData.getaway
  }

  set selectedGetaway(value: Getaway | null) {
    this.getawayData.getaway = value
  }

  get requiredFields(): any {
    return this.getawayData.requiredFields
  }

  set requiredFields(value: any) {
    this.getawayData.requiredFields = value
  }

  private get isFormInvalid(): boolean {
    if (this.selectedGetaway === null) return true

    return (!isEmpty(this.selectedGetaway?.required) && this.requiredFields === null)
  }

  private getShopImage(code: string): string {
    return `https://client.chatkeeper.info/assets/getaways/${ code }.png`
  }

  selectGetaway(getaway: Getaway): void {
    if (!this.selectedGetaway || this.selectedGetaway.code !== getaway.code) {
      this.requiredFields = null
      this.selectedGetaway = cloneDeep(getaway)
    }
  }

  onFormFill(data: any): void {
    this.requiredFields = data
  }

  created():void {
    this.selectedGetaway = this.getaways[0]
  }
}
